module.exports = __webpack_public_path__ + "assets/img/title.b81b86aa.png";